import React, { useState } from "react";
import { Row, Col, Form, Input, Button, notification } from "antd";
import { Link } from "react-router-dom/cjs/react-router-dom";
import { useHistory } from "react-router-dom";
import utilService from "../../util/utils.service";
import Logo from "../../assets/images/logo.png";
import "./contactUs.less";
import contactService from "../../services/contact-us";
import notificationService from "../../util/notification.service";
import { unAuthenticatedRoutes } from "../../routes/constant";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
const FormItem = Form.Item;

const ContactUs = (values) => {
    const history = useHistory();
    const [form] = Form.useForm();
    const [loading, setLoading] = useState(false);

    const onFinish = async (values) => {
        setLoading(true);
        const payload = {
            name: values.name,
            email: values.email,
            phone: values.phoneNumber,
            message: values.additionalMessage,
        };

        const { ok } = await contactService.contactUs(payload);

        if (ok) {
            form.resetFields();
            notificationService.success("Thank you for your comments");
            // utilService.redirectTo(unAuthenticatedRoutes.LOGIN);
            history.replace("/login");
        }
        setLoading(false);
    };
    return (
        <Row
            className="auth-background register-wrap reset-pass-main œ¬-pt-2"
            justify={"center"}
            align={"middle"}
        >
            <Col lg={12} xl={12} xxl={12} md={20}>
                <Row gutter={[0, 25]} type="flex">
                    <Col span={24} align="middle" justify="center">
                        <div className="gx-app-logo">
                            <img src={Logo} />
                        </div>
                        <div className="gx-app-logo">
                            <h2>Contact Us</h2>
                        </div>
                    </Col>

                    <Col span={24}>
                        <div className="gx-app-login-main-content">
                            <div className="gx-app-login-content input-field">
                                <Form
                                    name="basic"
                                    onFinish={onFinish}
                                    form={form}
                                    className="gx-signin-form gx-form-row0"
                                >
                                    <Form.Item
                                        name="name"
                                        rules={[
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    if (!value) {
                                                        return Promise.reject(
                                                            "Name is required"
                                                        );
                                                    }
                                                    if (value.length < 3) {
                                                        return Promise.reject(
                                                            "Username must be atleast 3 characters"
                                                        );
                                                    }
                                                    if (value.length > 30) {
                                                        return Promise.reject(
                                                            "Username can be atmost 30 characters"
                                                        );
                                                    }

                                                    return Promise.resolve();
                                                },
                                            }),
                                        ]}
                                    >
                                        <Input
                                            className="inpt"
                                            placeholder="Enter your name..."
                                        />
                                    </Form.Item>

                                    <Form.Item
                                        name="email"
                                        rules={[
                                            {
                                                type: "email",
                                                message:
                                                    "The input is not valid E-mail!",
                                            },
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {
                                                    if (!value) {
                                                        return Promise.reject(
                                                            "Name is required"
                                                        );
                                                    }
                                                    if (value.length < 3) {
                                                        return Promise.reject(
                                                            "Username must be atleast 3 characters"
                                                        );
                                                    }
                                                    if (value.length > 30) {
                                                        return Promise.reject(
                                                            "Username can be atmost 30 characters"
                                                        );
                                                    }

                                                    return Promise.resolve();
                                                },
                                            }),
                                        ]}
                                    >
                                        <Input
                                            className="inpt"
                                            placeholder="Email"
                                        />
                                    </Form.Item>
                                    <Form.Item
                                        name="phoneNumber"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Phone number is required",
                                            },
                                            ({ getFieldValue }) => ({
                                                validator(_, value) {                                                    
                                                    if(value && !isValidPhoneNumber(value)){
                                                        return Promise.reject("Invalid phone number")
                                                    }
                                                    return Promise.resolve();
                                                },
                                            }),
                                        ]}
                                    >
                                        <span className="kl-custom-input-container">
                                        <PhoneInput
                                            smartCaret
                                            defaultCountry="US"
                                            international
                                            placeholder="Enter phone number"                          
                                            onChange={(phone) => {                                                
                                                if(phone && !isValidPhoneNumber(phone)){
                                                    form.setFields([{ name: "phoneNumber", errors: ["Invalid phone number"] }])
                                                }
                                            }}
                                        />
                                        </span>
                                    </Form.Item>
                                    {/* <Form.Item
                                        name="phoneNumber"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Phone number is required",
                                            },
                                        ]}
                                    >
                                        <Input
                                            className="inpt"
                                            type="number"
                                            placeholder="Please enter Phone Number"
                                        />
                                    </Form.Item> */}

                                    <Form.Item
                                        name="additionalMessage"
                                        rules={[
                                            {
                                                required: true,
                                                message:
                                                    "Your suggestion is important to us",
                                            },
                                        ]}
                                    >
                                        <Input
                                            className="inpt"
                                            placeholder="What can we help you with?"
                                        />
                                    </Form.Item>
                                    <FormItem>
                                        <Button
                                            type="primary"
                                            className="gx-mt-4 butn"
                                            htmlType="submit"
                                            loading={loading}
                                        >
                                            Submit
                                        </Button>
                                    </FormItem>

                                    <Row justify={"center"}>
                                        <Col>
                                            <p>
                                                Have an account? &nbsp;
                                                <Link
                                                    style={{
                                                        color: `#FB8762`,
                                                    }}
                                                    to="/login"
                                                >
                                                    Sign in
                                                </Link>
                                            </p>
                                        </Col>
                                    </Row>
                                </Form>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Col>
        </Row>
    );
};

export default ContactUs;
